import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useCustomToast } from 'design-system';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { downloadFile } from 'utils/download-file';

type TData = Record<string, any>;
type TError = AxiosError;
type TQueryKey = string[];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useDownloadImageApi(imageURL: string, ext: string, options?: Options): ReturnType {
  const toast = useCustomToast();

  const queryFn = async () => {
    try {
      await axios
        .get(imageURL, {
          responseType: 'arraybuffer',
        })
        .then((response) => {
          downloadFile(response.data, `licence.${ext}`);
        });
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([imageURL, ext], queryFn, {
    enabled: false,
    ...options,
  });
}
